import axios from '@/libs/api.request'
import config from '@/config'

const baseCloudUrl = config.basePrivateCloudUrl
const privateCloudBaseUrl = baseCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudServer = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'server/',
    params: params,
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const getPrivateCloudAllServer = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_server_list/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudServer = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'server/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudServer = (data, id) => {
  let url = privateCloudBaseUrl + 'server/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    needPrivateCloudProjectHeader: true,
    method: method
  })
}

export const deletePrivateCloudServer = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'server/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}

export const actionPrivateCloudServer = (data, serverId) => {
  return axios.request({
    url: privateCloudBaseUrl + 'server/' + serverId + '/action/',
    needPrivateCloudProjectHeader: true,
    traditional: true,
    data: data,
    method: 'post'
  })
}

export const getVncConsolePrivateCloudServer = (data, serverId) => {
  return axios.request({
    url: privateCloudBaseUrl + 'server/' + serverId + '/remote_console/',
    needPrivateCloudProjectHeader: true,
    traditional: true,
    data: data,
    method: 'post'
  })
}

export const getVolumeAttachmentPrivateCloudServerList = (serverId) => {
  return axios.request({
    url: privateCloudBaseUrl + 'server/' + serverId + '/volume_attachments/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const volumeAttachmentPrivateCloudServer = (data, serverId) => {
  return axios.request({
    url: privateCloudBaseUrl + 'server/' + serverId + '/volume_attachments/',
    needPrivateCloudProjectHeader: true,
    traditional: true,
    data: data,
    method: 'post'
  })
}

export const deleteVolumeAttachmentPrivateCloudServer = (reqData, serverId) => {
  return axios.request({
    url: privateCloudBaseUrl + 'server/' + serverId + '/volume_attachments/',
    needPrivateCloudProjectHeader: true,
    data: reqData,
    method: 'delete'
  })
}

export const getPrivateCloudServerSecurityGroups = (serverId) => {
  return axios.request({
    url: privateCloudBaseUrl + 'server/' + serverId + '/security_groups/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}
